export default "__VITE_ASSET__DqX0mIEh__"